
/**
 * 數字千分號
 * price 金額
 * currency 幣別符號：false-不顯示
 */
export const priceCommafy = (price, currency) => {
  price = price + '';
	var re = /(-?\d+)(\d{3})/
	while (re.test(price)) {
		price = price.replace(re, '$1,$2');
	}
	if(currency !== false) {
		price = '$' + price;	
	}
	return price;
}